import { render, staticRenderFns } from "./ShiftOld.vue?vue&type=template&id=fdf05ff6&"
import script from "./ShiftOld.vue?vue&type=script&lang=js&"
export * from "./ShiftOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports